import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import * as AT from "./actionTypes";
import { RootState } from "../../../../models";
import * as Ajax from "../../app/Ajax";
import { API_URL_FETCH_WEBDEALS } from "../api";

export const fetchWebdeals =
    (sku: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch) => {
        return dispatch({
            type: AT.CHECKOUT_FETCH_WEBDEALS,
            payload: Ajax.post(
                {
                    url: API_URL_FETCH_WEBDEALS,
                    data: {
                        sku,
                    },
                },
                dispatch,
            ),
        });
    };
